var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha",attrs:{"title":_vm.$t('i18n.clickToRefreshCaptcha')}},[_c('img',{attrs:{"src":_vm.captcha,"alt":_vm.$t('i18n.captcha')},on:{"click":_vm.refresh}})])}
var staticRenderFns = []

export { render, staticRenderFns }